import * as React from "react";
export function useObserved(f, deps, signal, signalDeps) {
    const [version, setVersion] = React.useState(1);
    React.useLayoutEffect(() => {
        const stream = signal();
        const subscription = stream.subscribe(() => {
            setVersion((it) => it + 1);
        });
        return () => subscription.unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, signalDeps);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, react-hooks/exhaustive-deps
    return React.useMemo(f, [version, ...deps]);
}
